"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
    _this.scrollToTop = _this.scrollToTop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.modal = document.createElement('div');
      document.body.appendChild(this.modal);
      this.renderLayer();

      if (this.props.escClose) {
        document.addEventListener('keyup', function (e) {
          if (e.code === 'Escape') {
            e.preventDefault();

            _this2.props.closeHandler(e);
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _reactDom.default.unmountComponentAtNode(this.modal);

      document.body.removeChild(this.modal);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderLayer();

      if (this.props.isOpen) {
        document.documentElement.classList.add('modal-is-open');
      } else {
        document.documentElement.classList.remove('modal-is-open');
      }
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      if (this.props.id) {
        var contentEl = document.getElementById(this.props.id).querySelector('.modal__content');
        contentEl.scrollTop = 0;
      }
    }
  }, {
    key: "renderLayer",
    value: function renderLayer() {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.id,
        className: ['modal', this.props.classes, this.props.isOpen ? 'is-open' : ''].join(' ')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal__background",
        onClick: this.props.backgroundClickClose ? this.props.closeHandler : null
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal__content"
      }, this.props.children)), this.modal);
    }
  }, {
    key: "render",
    value: function render() {
      // Render a placeholder
      return /*#__PURE__*/_react.default.createElement("div", null);
    }
  }]);

  return Modal;
}(_react.default.Component);

Modal.defaultProps = {
  closeHandler: function closeHandler() {},
  escClose: false,
  backgroundClickClose: false,
  classes: ''
};
Modal.propTypes = {
  id: _propTypes.default.any,
  closeHandler: _propTypes.default.func,
  escClose: _propTypes.default.bool,
  backgroundClickClose: _propTypes.default.bool,
  classes: _propTypes.default.string,
  isOpen: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  children: _propTypes.default.any
};
var _default = Modal;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/modal/index.js
// module id = 45
// module chunks = 0